module.exports = __webpack_public_path__ + "img/weibaoReport5.190f379e.png";